import * as Yup from 'yup';

export const model = {
  review: {
    name: 'review',
    inputType: 'textarea',
    placeholder: 'Write a review...',
  },
  rating: {
    name: 'rating',
    inputType: 'number',
  },
};

export const validationSchema = Yup.object().shape({
  [model.review.name]: Yup.string().required('Required'),
  [model.rating.name]: Yup.number()
    .required('Rating is required')
    .min(1, 'Rating must be at least 1')
    .max(5, 'Rating can be at most 5'),
});

export const initialValues = (data: any) => ({
  [model.review.name]: data?.review ?? '',
  [model.rating.name]: data?.rating ?? 0,
});
